import { API_PREFIX } from '@/config/api'
import type { PartnerFilters } from '@/types/filters/PartnerFilters'
import type { PartnerModel } from '@/types/partners/PartnerModel'
import { auth } from '@rfc/rfc-components-library/helpers'
import type { PaginationDataType, PaginationType } from '@rfc/rfc-components-library/types'
import { buildQueryUrl } from '@rfc/rfc-components-library/utils'

const PARTNER_API_PREFIX = `${API_PREFIX}/partners`

const partnerApi = {
    getPartners: (
        params?: Partial<PaginationType & PartnerFilters>,
        noQueryParams?: boolean
    ): Promise<PaginationDataType<PartnerModel[]>> =>
        auth
            .get(`${PARTNER_API_PREFIX}${buildQueryUrl(params, noQueryParams)}`)
            .then(res => res.data),
    getPartner: (id: number) => auth.get(`${PARTNER_API_PREFIX}/${id}`),

    addPartner: (id: number, data: PartnerModel) => auth.post(`${PARTNER_API_PREFIX}/${id}`),
    updatePartner: (id: number, data: PartnerModel) => auth.patch(`${PARTNER_API_PREFIX}/${id}`),
    deletePartner: (id: number) => auth.delete(`${PARTNER_API_PREFIX}/${id}`)
}

export default partnerApi
